import { systemMessageOperations } from 'ducks/systemMessage';
import * as actions from './actions';

export const submitMisprintForm = (data) => (dispatch) =>
	dispatch(
		systemMessageOperations.withSystemMessage(
			dispatch(actions.submitMisprintForm(data)),
			'Ваше сообщение отправлено!',
			'При отправке произошла ошибка. Попробуйте еще\u00A0раз.'
		)
	);
